module.exports = __webpack_public_path__ + "img/vertical_3_3_8004.9615ba03.png";